import React from "react";
import documentationScript from './documentationScript.json';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { styles, StyledCell, StyledRow, StyledTable } from "./styles";
import DocumentationBoldText from "./DocumentationBoldText";


export const GetBasicTable = () => {
  function createData(paramaterType, name, type, description) {
    return { paramaterType, name, type, description };
  }

  const rows = [
    createData(
      documentationScript.formulary.getBasic.paramRow1,
      documentationScript.formulary.getBasic.nameRow1,
      documentationScript.formulary.getBasic.typeRow1,
      documentationScript.formulary.getBasic.descRow1
    ),
  ];

  return (
    <StyledTable>
      <Table sx={{ width: "auto" }} aria-label="GET /Basic table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getBasic.tableColumn1Title}
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getBasic.tableColumn2Title}
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getBasic.tableColumn3Title}
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getBasic.tableColumn4Title}
          </StyledCell>
        </StyledRow>

        <TableBody>
          {rows.map((row) => (
            <StyledRow key={row.name}>
              <StyledCell align="left">{row.paramaterType}</StyledCell>
              <StyledCell align="left">{row.name}</StyledCell>
              <StyledCell align="left">{row.type}</StyledCell>
              <StyledCell align="left">{row.description}</StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>
  );
};

export const GetMedicationKnowledgeTable = () => {
  function createData(paramaterType, name, type, description) {
    return { paramaterType, name, type, description };
  }

  const rows = [
    createData(
      documentationScript.formulary.getMedicationKnowledge.paramRow1,
      documentationScript.formulary.getMedicationKnowledge.nameRow1,
      documentationScript.formulary.getMedicationKnowledge.typeRow1,
      documentationScript.formulary.getMedicationKnowledge.descRow1
    ),
  ];

  return (
    <StyledTable>
      <Table sx={{ width: "auto" }} aria-label="GET /MedicationKnowledge table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getMedicationKnowledge.tableColumn1Title}
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getMedicationKnowledge.tableColumn2Title}
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getMedicationKnowledge.tableColumn3Title}
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getMedicationKnowledge.tableColumn4Title}
          </StyledCell>
        </StyledRow>

        <TableBody>
          {rows.map((row) => (
            <StyledRow key={row.name}>
              <StyledCell align="left">{row.paramaterType}</StyledCell>
              <StyledCell align="left">{row.name}</StyledCell>
              <StyledCell align="left">{row.type}</StyledCell>
              <StyledCell align="left">{row.description}</StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>
  );
};

export const GetInsurancePlanTable = () => {
  function createData(paramaterType, name, type, description) {
    return { paramaterType, name, type, description };
  }

  const rows = [
    createData(
      documentationScript.formulary.getInsurancePlan.paramRow1,
      documentationScript.formulary.getInsurancePlan.nameRow1,
      documentationScript.formulary.getInsurancePlan.typeRow1,
      documentationScript.formulary.getInsurancePlan.descRow1
    ),
  ];

  return (
    <StyledTable>
      <Table sx={{ width: "auto" }} aria-label="GET /InsurancePlan table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getInsurancePlan.tableColumn1Title}
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getInsurancePlan.tableColumn2Title}
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getInsurancePlan.tableColumn3Title}
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {documentationScript.formulary.getInsurancePlan.tableColumn4Title}
          </StyledCell>
        </StyledRow>

        <TableBody>
          {rows.map((row) => (
            <StyledRow key={row.name}>
              <StyledCell align="left">{row.paramaterType}</StyledCell>
              <StyledCell align="left">{row.name}</StyledCell>
              <StyledCell align="left">{row.type}</StyledCell>
              <StyledCell align="left">{row.description}</StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>
  );
};

export const SampleUserTable = ()=> {
    function createData(username,password) {
        return { username,password };
      }
    
      const SandboxSamplerows = [
        createData(documentationScript.getStarted.sandboxSampleUser.username1, documentationScript.getStarted.sandboxSampleUser.password1),
        createData(documentationScript.getStarted.sandboxSampleUser.username2, documentationScript.getStarted.sandboxSampleUser.password2),
        createData(documentationScript.getStarted.sandboxSampleUser.username3, documentationScript.getStarted.sandboxSampleUser.password3),
        createData(documentationScript.getStarted.sandboxSampleUser.username4, documentationScript.getStarted.sandboxSampleUser.password4),
        createData(documentationScript.getStarted.sandboxSampleUser.username5, documentationScript.getStarted.sandboxSampleUser.password5),
        createData(documentationScript.getStarted.sandboxSampleUser.username6, documentationScript.getStarted.sandboxSampleUser.password6),
      ];
      return(<StyledTable>
        <Table sx={{ width:'auto' }} aria-label="simple table">
          <StyledRow>
            <StyledCell sx={styles.boldTableHeaders} align="left" >
              {
                documentationScript.getStarted.sandboxSampleUser
                  .tableColumn1Title
              }
            </StyledCell>
            <StyledCell sx={styles.boldTableHeaders} align="left" >
              {
                documentationScript.getStarted.sandboxSampleUser
                  .tableColumn1Title2
              }
            </StyledCell>
          </StyledRow>

          <TableBody>
            {SandboxSamplerows.map((row) => (
              <StyledRow key={row}>
                <StyledCell align="left" >
                  {row.username}
                </StyledCell>
                <StyledCell align="left" >
                  {row.password}
                </StyledCell>
              </StyledRow>
            ))}
          </TableBody>
        </Table>
      </StyledTable>)
};

export const AuthorizationCodeFlowTable = ()=> {
  function createData(name,required,example,description) {
      return {name,required,example,description};
    }
  
    const authorizationCodeFlowRows = [
      createData(documentationScript.authorization.codeFlow.nameRow1,documentationScript.authorization.codeFlow.requiredRow1,documentationScript.authorization.codeFlow.exampleRow1,documentationScript.authorization.codeFlow.descriptionRow1),
      createData(documentationScript.authorization.codeFlow.nameRow2,documentationScript.authorization.codeFlow.requiredRow2,documentationScript.authorization.codeFlow.exampleRow2,documentationScript.authorization.codeFlow.descriptionRow2),
      createData(documentationScript.authorization.codeFlow.nameRow3,documentationScript.authorization.codeFlow.requiredRow3,documentationScript.authorization.codeFlow.exampleRow3,documentationScript.authorization.codeFlow.descriptionRow3),
      createData(documentationScript.authorization.codeFlow.nameRow4,documentationScript.authorization.codeFlow.requiredRow4,documentationScript.authorization.codeFlow.exampleRow4,documentationScript.authorization.codeFlow.descriptionRow4),
      createData(documentationScript.authorization.codeFlow.nameRow5,documentationScript.authorization.codeFlow.requiredRow5,documentationScript.authorization.codeFlow.exampleRow5,documentationScript.authorization.codeFlow.descriptionRow5),
    ];
    return(<StyledTable >
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders} >
            {
              documentationScript.authorization.codeFlow.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.authorization.codeFlow.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.authorization.codeFlow.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.authorization.codeFlow.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {authorizationCodeFlowRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left">
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.required}
              </StyledCell>
              <StyledCell align="left" sx={{whiteSpace:'normal',wordBreak:'break-word', overflowWrap:'break-word'}}>
                {row.example}
              </StyledCell>
              <StyledCell align="left" sx={{whiteSpace:'normal',wordBreak:'break-word', overflowWrap:'break-word'}}>
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const AuthorizationPKCETable = ()=> {
  function createData(name,required,example,description) {
      return {name,required,example,description};
    }
  
    const authorizationPKCERows = [
      createData(documentationScript.authorization.pkce.nameRow1,documentationScript.authorization.pkce.requiredRow1,documentationScript.authorization.pkce.exampleRow1,documentationScript.authorization.pkce.descriptionRow1),
      createData(documentationScript.authorization.pkce.nameRow2,documentationScript.authorization.pkce.requiredRow2,documentationScript.authorization.pkce.exampleRow2,documentationScript.authorization.pkce.descriptionRow2),
      createData(documentationScript.authorization.pkce.nameRow3,documentationScript.authorization.pkce.requiredRow3,documentationScript.authorization.pkce.exampleRow3,documentationScript.authorization.pkce.descriptionRow3),
      createData(documentationScript.authorization.pkce.nameRow4,documentationScript.authorization.pkce.requiredRow4,documentationScript.authorization.pkce.exampleRow4,documentationScript.authorization.pkce.descriptionRow4),
      createData(documentationScript.authorization.pkce.nameRow5,documentationScript.authorization.pkce.requiredRow5,documentationScript.authorization.pkce.exampleRow5,documentationScript.authorization.pkce.descriptionRow5),
      createData(documentationScript.authorization.pkce.nameRow6,documentationScript.authorization.pkce.requiredRow6,documentationScript.authorization.pkce.exampleRow6,documentationScript.authorization.pkce.descriptionRow6),
      createData(documentationScript.authorization.pkce.nameRow7,documentationScript.authorization.pkce.requiredRow7,documentationScript.authorization.pkce.exampleRow7,documentationScript.authorization.pkce.descriptionRow7),
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.authorization.pkce.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.authorization.pkce.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.authorization.pkce.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.authorization.pkce.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {authorizationPKCERows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.required}
              </StyledCell>
              <StyledCell align="left" sx={{whiteSpace:'normal',wordBreak:'break-word', overflowWrap:'break-word'}}>
                {row.example}
              </StyledCell>
              <StyledCell align="left" sx={{whiteSpace:'normal',wordBreak:'break-word', overflowWrap:'break-word'}}>
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const AuthorizatioStep2Table = ()=> {
  function createData(key,value,exampleValue) {
      return {key,value,exampleValue};
    }
  
    const authorizationStep2Rows = [
      createData(documentationScript.authorization.step2.keyRow1,documentationScript.authorization.step2.valueRow1,documentationScript.authorization.step2.exampleValueRow1),
      createData(documentationScript.authorization.step2.keyRow2,documentationScript.authorization.step2.valueRow2,documentationScript.authorization.step2.exampleValueRow2),
      createData(documentationScript.authorization.step2.keyRow3,documentationScript.authorization.step2.valueRow3,documentationScript.authorization.step2.exampleValueRow3),
      createData(documentationScript.authorization.step2.keyRow4,documentationScript.authorization.step2.valueRow4,documentationScript.authorization.step2.exampleValueRow4),
      createData(documentationScript.authorization.step2.keyRow5,documentationScript.authorization.step2.valueRow5,documentationScript.authorization.step2.exampleValueRow5),
      createData(documentationScript.authorization.step2.keyRow6,documentationScript.authorization.step2.valueRow6,documentationScript.authorization.step2.exampleValueRow6),
    ];
    return(<StyledTable>
      <Table sx={{ width: 'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.authorization.step2.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.authorization.step2.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.authorization.step2.tableColumn3Title
            }
          </StyledCell>
          
        </StyledRow>

        <TableBody>
          {authorizationStep2Rows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.key}
              </StyledCell>
              <StyledCell align="left" >
                <DocumentationBoldText text={row.value} boldText={[documentationScript.authorization.step2.requiredIfPKCE]}/>
              </StyledCell>
              <StyledCell align="left" >
                {row.exampleValue}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};


export const GetCoverageTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getCoverageRows = [
      createData(documentationScript.patientAccess.getCoverage.paramRow1,documentationScript.patientAccess.getCoverage.nameRow1,documentationScript.patientAccess.getCoverage.typeRow1,documentationScript.patientAccess.getCoverage.descRow1),
      createData(documentationScript.patientAccess.getCoverage.paramRow2,documentationScript.patientAccess.getCoverage.nameRow2,documentationScript.patientAccess.getCoverage.typeRow2,documentationScript.patientAccess.getCoverage.descRow2),
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCoverage.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCoverage.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCoverage.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCoverage.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getCoverageRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetCoverageIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getCoverageIDRows = [
      createData(documentationScript.patientAccess.getCoverageID.paramRow1,documentationScript.patientAccess.getCoverageID.nameRow1,documentationScript.patientAccess.getCoverageID.typeRow1,documentationScript.patientAccess.getCoverageID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCoverageID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCoverageID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCoverageID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCoverageID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getCoverageIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetExplanationOfBenefitTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getExplanationOfBenefitRows = [
      createData(documentationScript.patientAccess.getBenefitExplanation.paramRow1,documentationScript.patientAccess.getBenefitExplanation.nameRow1,documentationScript.patientAccess.getBenefitExplanation.typeRow1,documentationScript.patientAccess.getBenefitExplanation.descRow1),
      createData(documentationScript.patientAccess.getBenefitExplanation.paramRow2,documentationScript.patientAccess.getBenefitExplanation.nameRow2,documentationScript.patientAccess.getBenefitExplanation.typeRow2,documentationScript.patientAccess.getBenefitExplanation.descRow2),
      createData(documentationScript.patientAccess.getBenefitExplanation.paramRow3,documentationScript.patientAccess.getBenefitExplanation.nameRow3,documentationScript.patientAccess.getBenefitExplanation.typeRow3,documentationScript.patientAccess.getBenefitExplanation.descRow3),
      createData(documentationScript.patientAccess.getBenefitExplanation.paramRow4,documentationScript.patientAccess.getBenefitExplanation.nameRow4,documentationScript.patientAccess.getBenefitExplanation.typeRow4,documentationScript.patientAccess.getBenefitExplanation.descRow4),
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getBenefitExplanation.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getBenefitExplanation.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getBenefitExplanation.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getBenefitExplanation.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getExplanationOfBenefitRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetExplanationOfBenefitIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getExplanationOfBenefitIDRows = [
      createData(documentationScript.patientAccess.getBenefitExplanationID.paramRow1,documentationScript.patientAccess.getBenefitExplanationID.nameRow1,documentationScript.patientAccess.getBenefitExplanationID.typeRow1,documentationScript.patientAccess.getBenefitExplanationID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getBenefitExplanationID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getBenefitExplanationID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getBenefitExplanationID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getBenefitExplanationID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getExplanationOfBenefitIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetPatientTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getPatientRows = [
      createData(documentationScript.patientAccess.getPatient.paramRow1,documentationScript.patientAccess.getPatient.nameRow1,documentationScript.patientAccess.getPatient.typeRow1,documentationScript.patientAccess.getPatient.descRow1),
      createData(documentationScript.patientAccess.getPatient.paramRow2,documentationScript.patientAccess.getPatient.nameRow2,documentationScript.patientAccess.getPatient.typeRow2,documentationScript.patientAccess.getPatient.descRow2),
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getPatient.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getPatient.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getPatient.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getPatient.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getPatientRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetPatientIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getPatientIDRows = [
      createData(documentationScript.patientAccess.getPatientID.paramRow1,documentationScript.patientAccess.getPatientID.nameRow1,documentationScript.patientAccess.getPatientID.typeRow1,documentationScript.patientAccess.getPatientID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getPatientID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getPatientID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getPatientID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getPatientID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getPatientIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetConditionTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getConditionRows = [
      createData(documentationScript.patientAccess.getCondition.paramRow1,documentationScript.patientAccess.getCondition.nameRow1,documentationScript.patientAccess.getCondition.typeRow1,documentationScript.patientAccess.getCondition.descRow1),
      createData(documentationScript.patientAccess.getCondition.paramRow2,documentationScript.patientAccess.getCondition.nameRow2,documentationScript.patientAccess.getCondition.typeRow2,documentationScript.patientAccess.getCondition.descRow2),
      createData(documentationScript.patientAccess.getCondition.paramRow3,documentationScript.patientAccess.getCondition.nameRow3,documentationScript.patientAccess.getCondition.typeRow3,documentationScript.patientAccess.getCondition.descRow3),
      createData(documentationScript.patientAccess.getCondition.paramRow4,documentationScript.patientAccess.getCondition.nameRow4,documentationScript.patientAccess.getCondition.typeRow4,documentationScript.patientAccess.getCondition.descRow4),
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCondition.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCondition.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCondition.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getCondition.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getConditionRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left">
                {row.type}
              </StyledCell>
              <StyledCell align="left">
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetConditionIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getConditionIDRows = [
      createData(documentationScript.patientAccess.getConditionID.paramRow1,documentationScript.patientAccess.getConditionID.nameRow1,documentationScript.patientAccess.getConditionID.typeRow1,documentationScript.patientAccess.getConditionID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getConditionID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getConditionID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getConditionID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getConditionID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getConditionIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetEncounterTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getEncounterRows = [
      createData(documentationScript.patientAccess.getEncounter.paramRow1,documentationScript.patientAccess.getEncounter.nameRow1,documentationScript.patientAccess.getEncounter.typeRow1,documentationScript.patientAccess.getEncounter.descRow1),
      createData(documentationScript.patientAccess.getEncounter.paramRow2,documentationScript.patientAccess.getEncounter.nameRow2,documentationScript.patientAccess.getEncounter.typeRow2,documentationScript.patientAccess.getEncounter.descRow2),
      createData(documentationScript.patientAccess.getEncounter.paramRow3,documentationScript.patientAccess.getEncounter.nameRow3,documentationScript.patientAccess.getEncounter.typeRow3,documentationScript.patientAccess.getEncounter.descRow3),
      createData(documentationScript.patientAccess.getEncounter.paramRow4,documentationScript.patientAccess.getEncounter.nameRow4,documentationScript.patientAccess.getEncounter.typeRow4,documentationScript.patientAccess.getEncounter.descRow4),
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getEncounter.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getEncounter.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getEncounter.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getEncounter.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getEncounterRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetEncounterIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getEncounterIDRows = [
      createData(documentationScript.patientAccess.getEncounterID.paramRow1,documentationScript.patientAccess.getEncounterID.nameRow1,documentationScript.patientAccess.getEncounterID.typeRow1,documentationScript.patientAccess.getEncounterID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getEncounterID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getEncounterID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getEncounterID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getEncounterID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getEncounterIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetMedicationDispenseTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getMedicationDispenseRows = [
      createData(documentationScript.patientAccess.getMedicationDispense.paramRow1,documentationScript.patientAccess.getMedicationDispense.nameRow1,documentationScript.patientAccess.getMedicationDispense.typeRow1,documentationScript.patientAccess.getMedicationDispense.descRow1),
      createData(documentationScript.patientAccess.getMedicationDispense.paramRow2,documentationScript.patientAccess.getMedicationDispense.nameRow2,documentationScript.patientAccess.getMedicationDispense.typeRow2,documentationScript.patientAccess.getMedicationDispense.descRow2),
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationDispense.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationDispense.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationDispense.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationDispense.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getMedicationDispenseRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetMedicationDispenseIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getMedicationDispenseIDRows = [
      createData(documentationScript.patientAccess.getMedicationDispenseID.paramRow1,documentationScript.patientAccess.getMedicationDispenseID.nameRow1,documentationScript.patientAccess.getMedicationDispenseID.typeRow1,documentationScript.patientAccess.getMedicationDispenseID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationDispenseID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationDispenseID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationDispenseID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationDispenseID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getMedicationDispenseIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetMedicationRequestTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getMedicationRequestRows = [
      createData(documentationScript.patientAccess.getMedicationRequest.paramRow1,documentationScript.patientAccess.getMedicationRequest.nameRow1,documentationScript.patientAccess.getMedicationRequest.typeRow1,documentationScript.patientAccess.getMedicationRequest.descRow1),
      createData(documentationScript.patientAccess.getMedicationRequest.paramRow2,documentationScript.patientAccess.getMedicationRequest.nameRow2,documentationScript.patientAccess.getMedicationRequest.typeRow2,documentationScript.patientAccess.getMedicationRequest.descRow2),
      createData(documentationScript.patientAccess.getMedicationRequest.paramRow3,documentationScript.patientAccess.getMedicationRequest.nameRow3,documentationScript.patientAccess.getMedicationRequest.typeRow3,documentationScript.patientAccess.getMedicationRequest.descRow3),
      createData(documentationScript.patientAccess.getMedicationRequest.paramRow4,documentationScript.patientAccess.getMedicationRequest.nameRow4,documentationScript.patientAccess.getMedicationRequest.typeRow4,documentationScript.patientAccess.getMedicationRequest.descRow4),
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationRequest.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationRequest.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationRequest.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationRequest.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getMedicationRequestRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetMedicationRequestIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getMedicationRequestIDRows = [
      createData(documentationScript.patientAccess.getMedicationRequestID.paramRow1,documentationScript.patientAccess.getMedicationRequestID.nameRow1,documentationScript.patientAccess.getMedicationRequestID.typeRow1,documentationScript.patientAccess.getMedicationRequestID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationRequestID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationRequestID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationRequestID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getMedicationRequestID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getMedicationRequestIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetObservationTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getObservationRows = [
      createData(documentationScript.patientAccess.getObservation.paramRow1,documentationScript.patientAccess.getObservation.nameRow1,documentationScript.patientAccess.getObservation.typeRow1,documentationScript.patientAccess.getObservation.descRow1),
      createData(documentationScript.patientAccess.getObservation.paramRow2,documentationScript.patientAccess.getObservation.nameRow2,documentationScript.patientAccess.getObservation.typeRow2,documentationScript.patientAccess.getObservation.descRow2),
      createData(documentationScript.patientAccess.getObservation.paramRow3,documentationScript.patientAccess.getObservation.nameRow3,documentationScript.patientAccess.getObservation.typeRow3,documentationScript.patientAccess.getObservation.descRow3),
      createData(documentationScript.patientAccess.getObservation.paramRow4,documentationScript.patientAccess.getObservation.nameRow4,documentationScript.patientAccess.getObservation.typeRow4,documentationScript.patientAccess.getObservation.descRow4),
      createData(documentationScript.patientAccess.getObservation.paramRow5,documentationScript.patientAccess.getObservation.nameRow5,documentationScript.patientAccess.getObservation.typeRow5,documentationScript.patientAccess.getObservation.descRow5),
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders} style={{width:'110px'}}>
            {
              documentationScript.patientAccess.getObservation.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getObservation.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getObservation.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getObservation.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getObservationRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetObservationIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getObservationIDRows = [
      createData(documentationScript.patientAccess.getObservationID.paramRow1,documentationScript.patientAccess.getObservationID.nameRow1,documentationScript.patientAccess.getObservationID.typeRow1,documentationScript.patientAccess.getObservationID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getObservationID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getObservationID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getObservationID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getObservationID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getObservationIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetProcedureTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getProcedureRows = [
      createData(documentationScript.patientAccess.getProcedure.paramRow1,documentationScript.patientAccess.getProcedure.nameRow1,documentationScript.patientAccess.getProcedure.typeRow1,documentationScript.patientAccess.getProcedure.descRow1),
      createData(documentationScript.patientAccess.getProcedure.paramRow2,documentationScript.patientAccess.getProcedure.nameRow2,documentationScript.patientAccess.getProcedure.typeRow2,documentationScript.patientAccess.getProcedure.descRow2),
      createData(documentationScript.patientAccess.getProcedure.paramRow3,documentationScript.patientAccess.getProcedure.nameRow3,documentationScript.patientAccess.getProcedure.typeRow3,documentationScript.patientAccess.getProcedure.descRow3),
      createData(documentationScript.patientAccess.getProcedure.paramRow4,documentationScript.patientAccess.getProcedure.nameRow4,documentationScript.patientAccess.getProcedure.typeRow4,documentationScript.patientAccess.getProcedure.descRow4),
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getProcedure.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getProcedure.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getProcedure.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getProcedure.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getProcedureRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetProcedureIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getProcedureIDRows = [
      createData(documentationScript.patientAccess.getProcedureID.paramRow1,documentationScript.patientAccess.getProcedureID.nameRow1,documentationScript.patientAccess.getProcedureID.typeRow1,documentationScript.patientAccess.getProcedureID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getProcedureID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getProcedureID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getProcedureID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getProcedureID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getProcedureIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetImmunizationTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getImmunizationRows = [
      createData(documentationScript.patientAccess.getImmunization.paramRow1,documentationScript.patientAccess.getImmunization.nameRow1,documentationScript.patientAccess.getImmunization.typeRow1,documentationScript.patientAccess.getImmunization.descRow1),
      createData(documentationScript.patientAccess.getImmunization.paramRow2,documentationScript.patientAccess.getImmunization.nameRow2,documentationScript.patientAccess.getImmunization.typeRow2,documentationScript.patientAccess.getImmunization.descRow2),
      createData(documentationScript.patientAccess.getImmunization.paramRow3,documentationScript.patientAccess.getImmunization.nameRow3,documentationScript.patientAccess.getImmunization.typeRow3,documentationScript.patientAccess.getImmunization.descRow3),
      createData(documentationScript.patientAccess.getImmunization.paramRow4,documentationScript.patientAccess.getImmunization.nameRow4,documentationScript.patientAccess.getImmunization.typeRow4,documentationScript.patientAccess.getImmunization.descRow4),
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getImmunization.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getImmunization.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getImmunization.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getImmunization.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getImmunizationRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetImmunizationIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getImmunizationIDRows = [
      createData(documentationScript.patientAccess.getImmunizationID.paramRow1,documentationScript.patientAccess.getImmunizationID.nameRow1,documentationScript.patientAccess.getImmunizationID.typeRow1,documentationScript.patientAccess.getImmunizationID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getImmunizationID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getImmunizationID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getImmunizationID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.patientAccess.getImmunizationID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getImmunizationIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetHealthcareServiceTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getHealthcareServiceRows = [
      createData(documentationScript.providerDirectory.getHealthcareService.paramRow1,documentationScript.providerDirectory.getHealthcareService.nameRow1,documentationScript.providerDirectory.getHealthcareService.typeRow1,documentationScript.providerDirectory.getHealthcareService.descRow1),
      createData(documentationScript.providerDirectory.getHealthcareService.paramRow2,documentationScript.providerDirectory.getHealthcareService.nameRow2,documentationScript.providerDirectory.getHealthcareService.typeRow2,documentationScript.providerDirectory.getHealthcareService.descRow2),
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getHealthcareService.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getHealthcareService.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getHealthcareService.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getHealthcareService.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getHealthcareServiceRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetHealthcareServiceIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getHealthcareServiceIDRows = [
      createData(documentationScript.providerDirectory.getHealthcareServiceID.paramRow1,documentationScript.providerDirectory.getHealthcareServiceID.nameRow1,documentationScript.providerDirectory.getHealthcareServiceID.typeRow1,documentationScript.providerDirectory.getHealthcareServiceID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getHealthcareServiceID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getHealthcareServiceID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getHealthcareServiceID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getHealthcareServiceID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getHealthcareServiceIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetOrganizationTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getOrganizationRows = [
      createData(documentationScript.providerDirectory.getOrganization.paramRow1,documentationScript.providerDirectory.getOrganization.nameRow1,documentationScript.providerDirectory.getOrganization.typeRow1,documentationScript.providerDirectory.getOrganization.descRow1),
      createData(documentationScript.providerDirectory.getOrganization.paramRow2,documentationScript.providerDirectory.getOrganization.nameRow2,documentationScript.providerDirectory.getOrganization.typeRow2,documentationScript.providerDirectory.getOrganization.descRow2),
      createData(documentationScript.providerDirectory.getOrganization.paramRow3,documentationScript.providerDirectory.getOrganization.nameRow3,documentationScript.providerDirectory.getOrganization.typeRow3,documentationScript.providerDirectory.getOrganization.descRow3),
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders} style={{width:'110px'}}>
            {
              documentationScript.providerDirectory.getOrganization.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getOrganization.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getOrganization.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getOrganization.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getOrganizationRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetOrganizationIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getOrganizationIDRows = [
      createData(documentationScript.providerDirectory.getOrganizationID.paramRow1,documentationScript.providerDirectory.getOrganizationID.nameRow1,documentationScript.providerDirectory.getOrganizationID.typeRow1,documentationScript.providerDirectory.getOrganizationID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getOrganizationID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getOrganizationID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getOrganizationID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getOrganizationID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getOrganizationIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetLocationTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getLocationRows = [
      createData(documentationScript.providerDirectory.getLocation.paramRow1,documentationScript.providerDirectory.getLocation.nameRow1,documentationScript.providerDirectory.getLocation.typeRow1,documentationScript.providerDirectory.getLocation.descRow1),
      createData(documentationScript.providerDirectory.getLocation.paramRow2,documentationScript.providerDirectory.getLocation.nameRow2,documentationScript.providerDirectory.getLocation.typeRow2,documentationScript.providerDirectory.getLocation.descRow2),
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getLocation.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getLocation.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getLocation.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getLocation.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getLocationRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetLocationIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getLocationIDRows = [
      createData(documentationScript.providerDirectory.getLocationID.paramRow1,documentationScript.providerDirectory.getLocationID.nameRow1,documentationScript.providerDirectory.getLocationID.typeRow1,documentationScript.providerDirectory.getLocationID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getLocationID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getLocationID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getLocationID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getLocationID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getLocationIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetPractitionerTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getPractitionerRows = [
      createData(documentationScript.providerDirectory.getPractitioner.paramRow1,documentationScript.providerDirectory.getPractitioner.nameRow1,documentationScript.providerDirectory.getPractitioner.typeRow1,documentationScript.providerDirectory.getPractitioner.descRow1),
      createData(documentationScript.providerDirectory.getPractitioner.paramRow2,documentationScript.providerDirectory.getPractitioner.nameRow2,documentationScript.providerDirectory.getPractitioner.typeRow2,documentationScript.providerDirectory.getPractitioner.descRow2),
      createData(documentationScript.providerDirectory.getPractitioner.paramRow3,documentationScript.providerDirectory.getPractitioner.nameRow3,documentationScript.providerDirectory.getPractitioner.typeRow3,documentationScript.providerDirectory.getPractitioner.descRow3),
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders} style={{width:'110px'}}>
            {
              documentationScript.providerDirectory.getPractitioner.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitioner.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitioner.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitioner.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getPractitionerRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetPractitionerIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getPractitionerIDRows = [
      createData(documentationScript.providerDirectory.getPractitionerID.paramRow1,documentationScript.providerDirectory.getPractitionerID.nameRow1,documentationScript.providerDirectory.getPractitionerID.typeRow1,documentationScript.providerDirectory.getPractitionerID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getPractitionerIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};

export const GetPractitionerRoleTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getPractitionerRoleRows = [
      createData(documentationScript.providerDirectory.getPractitionerRole.paramRow1,documentationScript.providerDirectory.getPractitionerRole.nameRow1,documentationScript.providerDirectory.getPractitionerRole.typeRow1,documentationScript.providerDirectory.getPractitionerRole.descRow1),
      createData(documentationScript.providerDirectory.getPractitionerRole.paramRow2,documentationScript.providerDirectory.getPractitionerRole.nameRow2,documentationScript.providerDirectory.getPractitionerRole.typeRow2,documentationScript.providerDirectory.getPractitionerRole.descRow2),
      createData(documentationScript.providerDirectory.getPractitionerRole.paramRow3,documentationScript.providerDirectory.getPractitionerRole.nameRow3,documentationScript.providerDirectory.getPractitionerRole.typeRow3,documentationScript.providerDirectory.getPractitionerRole.descRow3),
      createData(documentationScript.providerDirectory.getPractitionerRole.paramRow4,documentationScript.providerDirectory.getPractitionerRole.nameRow4,documentationScript.providerDirectory.getPractitionerRole.typeRow4,documentationScript.providerDirectory.getPractitionerRole.descRow4),
      createData(documentationScript.providerDirectory.getPractitionerRole.paramRow5,documentationScript.providerDirectory.getPractitionerRole.nameRow5,documentationScript.providerDirectory.getPractitionerRole.typeRow5,documentationScript.providerDirectory.getPractitionerRole.descRow5),
      createData(documentationScript.providerDirectory.getPractitionerRole.paramRow6,documentationScript.providerDirectory.getPractitionerRole.nameRow6,documentationScript.providerDirectory.getPractitionerRole.typeRow6,documentationScript.providerDirectory.getPractitionerRole.descRow6),
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders} style={{width:'110px'}}>
            {
              documentationScript.providerDirectory.getPractitionerRole.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerRole.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerRole.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerRole.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getPractitionerRoleRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};


export const GetPractitionerRoleIDTable = ()=> {
  function createData(paramaterType,name,type,description) {
      return {paramaterType,name,type,description};
    }
  
    const getPractitionerRoleIDRows = [
      createData(documentationScript.providerDirectory.getPractitionerRoleID.paramRow1,documentationScript.providerDirectory.getPractitionerRoleID.nameRow1,documentationScript.providerDirectory.getPractitionerRoleID.typeRow1,documentationScript.providerDirectory.getPractitionerRoleID.descRow1)
      
    ];
    return(<StyledTable>
      <Table sx={{ width:'auto' }} aria-label="simple table">
        <StyledRow>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerRoleID.tableColumn1Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerRoleID.tableColumn2Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerRoleID.tableColumn3Title
            }
          </StyledCell>
          <StyledCell align="left" sx={styles.boldTableHeaders}>
            {
              documentationScript.providerDirectory.getPractitionerRoleID.tableColumn4Title
            }
          </StyledCell>
        </StyledRow>

        <TableBody>
          {getPractitionerRoleIDRows.map((row) => (
            <StyledRow key={row}>
              <StyledCell align="left" >
                {row.paramaterType}
              </StyledCell>
              <StyledCell align="left" >
                {row.name}
              </StyledCell>
              <StyledCell align="left" >
                {row.type}
              </StyledCell>
              <StyledCell align="left" >
                {row.description}
              </StyledCell>
            </StyledRow>
          ))}
        </TableBody>
      </Table>
    </StyledTable>)
};